<template>
  <div class="v-tab" :class="{active}">
    <slot v-if="'default' in $slots"/>
    <div class="label" v-else>{{label}}</div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      default: ""
    },
    value: {
      default: ""
    }
  },
  computed: {
    inGroup() {
      return this.$parent.$vnode.componentOptions.tag == "v-tab-group";
    },
    active() {
      this.$parent.setSliderStyle(this, 300);
      return this.value === this.$parent.value;
    }
  },
  mounted() {
    this.$parent.setSliderStyle(this);
    this.$el.on(
      {
        click: "click",
        hover: "mouseenter"
      }[this.$parent.trigger],
      e => this.$disabled || this.$parent.setValue(this)
    );
  }
};
</script>

<style lang="less">
.v-tab {
  border: none;
  padding: 0px;
  outline: none;
  cursor: pointer;
  color: #666666;
  display: inline-block;
  background-color: transparent;
  transition: 300ms;
  &.active {
    color: #3e946a;
  }
  > .label {
    padding: 0px 15px;
    line-height: 40px;
  }
  &[disabled] {
    color: #cccccc;
  }
}
</style>
